import { format } from 'date-fns';
import { isDate } from 'date-fns';

export const formatDateToString = (
    date: Date | null,
    options: { detailed?: boolean } = {}
) => {
    if (!date || !isDate(date)) return '-';

    try {
        return format(
            date,
            options.detailed ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'
        );
    } catch (e) {
        console.error(e);
        return 'Ungültiges Datum';
    }
};
